export const TRIAL_DURATION_MILLIS = 7 * 24 * 3600 * 1000
